module.exports = __webpack_public_path__ + "img/11.1.5f1d4381.jpg";